import { Injectable, signal } from '@angular/core';

/**
 * Tracks whether the global app sidebar is collapsed (icons-only) or expanded.
 * Components can call `toggle()` from a hamburger button. Persisted to
 * localStorage so the preference survives page reloads.
 */
@Injectable({ providedIn: 'root' })
export class SidebarService {
    // Bumped from `qc.sidebar.collapsed` so the new slim-default takes effect
    // on existing users without needing to clear localStorage.
    private static readonly STORAGE_KEY = 'qc.sidebar.collapsed.v2';

    readonly collapsed = signal<boolean>(this.readInitial());

    toggle(): void {
        const next = !this.collapsed();
        this.collapsed.set(next);
        try {
            localStorage.setItem(SidebarService.STORAGE_KEY, next ? '1' : '0');
        } catch {
            /* localStorage may be unavailable; ignore */
        }
    }

    private readInitial(): boolean {
        try {
            const stored = localStorage.getItem(SidebarService.STORAGE_KEY);
            if (stored === '1' || stored === '0') return stored === '1';
        } catch {
            /* localStorage may be unavailable */
        }
        // Default: collapsed slim rail to match the QC design.
        return true;
    }
}
